<template>
  <v-btn class="btn-danger" @click="deleteChild()">解約</v-btn>
</template>

<script>
export default {
  props: {
    routes: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      cancelChildRoute: this.routes.cancelChildRoute,
    };
  },

  methods: {
    deleteChild() {
      if (
        window.confirm(
          "対象メンバーの定額受講コンテンツを解約します。よろしいですか?",
        )
      ) {
        window.location.href = this.cancelChildRoute;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-danger {
  background: #f5f5f5 !important;
  box-shadow: inherit;
  color: inherit;
}

@media screen and (max-width: 750px) {
  .v-btn {
    min-width: 60px !important;
    margin: 0 0 0 3px;
  }
}
</style>
